const getKey = (str) => str + '_' + process.env.APP_UUID
export default {
  set (key, value) {
    value = JSON.stringify(value)
    window.localStorage.setItem(getKey(key), value)
  },
  get (key) {
    let value
    try {
      const str = window.localStorage.getItem(getKey(key))
      value = JSON.parse(str)
    } catch (e) { console.error(e) }

    return value
  },
  remove (key) {
    window.localStorage.removeItem(key)
  }
}